
import { VideoContentKey } from '../../types';

export const videoContent: Record<VideoContentKey, string> = {
  newVideo: 'New Video',
  uploadVideo: 'Upload Video',
  selectVideoToCustomize: 'Select a video to customize',
  selectVideoFirst: 'Select a video first',
  noVideo: 'No Video',
  noVideoSelected: 'No video selected',
  videoTitle: 'Video Title',
  processing: 'Processing',
  views: 'views',
  videoControls: 'Video Controls',
  continueWatching: 'Continue Watching',
  continueWatchingDescription: 'When a user leaves the page, we save information about where they stopped watching the video. Upon return, we ask if they want to continue watching from where they left off or start from the beginning.',
  continueWatchingButton: 'Continue Watching',
  watchFromBeginning: 'Start from Beginning',
  continueWatchingTitle: 'Continue Watching?',
  continueWatchingPreview: 'Your image will be displayed when the user returns to the video',
  selectTemplate: 'Select a template for the "Continue Watching" feature',
  customUpload: 'Custom Upload',
  customizeOverlay: 'Customize Overlay',
  templates: 'Models',
  customizeBorder: 'Customize Border',
  enableBorder: 'Enable Border',
  borderColor: 'Border Color',
  borderWidth: 'Border Width',
  borderAnimation: 'Border Animation',
  borderRadius: 'Border Radius',
  borderStyle: 'Border Style',
  borderPosition: 'Border Position',
  borderSize: 'Border Size',
  borderTransparency: 'Border Transparency',
  borderType: 'Border Type',
  borderGlow: 'Border Glow',
  borderShadow: 'Border Shadow',
  borderHover: 'Border Hover Effect',
  videoUploaded: 'Video uploaded successfully',
  videoProcessingComplete: 'Your video has been processed and is ready to use',
  uploadCustomImage: 'Upload Custom Image',
  removeImage: 'Remove Image',
  dragToUpload: 'Drag and drop or click to upload',
  runningTests: 'Running Tests',
  testPerformance: 'Test Performance',
  completedTests: 'Completed Tests',
  // New thumbnail translations
  initialThumbnail: 'Initial Thumbnail',
  pauseThumbnail: 'Pause Thumbnail',
  endThumbnail: 'End Thumbnail',
  thumbnailOverlay: 'Thumbnail Overlay',
  thumbnailDescription: 'Customize thumbnails for key video moments',
  initialThumbnailDesc: 'Shown before video starts playing',
  pauseThumbnailDesc: 'Shown when video is paused',
  endThumbnailDesc: 'Shown when video ends',
  autoplayWarning: 'Initial thumbnail will not show if autoplay is enabled',
  recommendedDimensions: 'Recommended dimensions: 1280x720px',
  addButton: 'Add Button',
  buttonPosition: 'Button Position',
  buttonSize: 'Button Size'
};
